import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { useResizeAware } from '@wp-g2/utils';
import React, { useRef } from 'react';
import { useTabState } from 'reakit';
import { TabsContext } from './Tabs.Context';

function Tabs(props) {
  var children = props.children,
      otherProps = _objectWithoutProperties(props, ["children"]);

  var tab = useTabState(otherProps);
  var listRef = useRef();

  var _useResizeAware = useResizeAware(),
      _useResizeAware2 = _slicedToArray(_useResizeAware, 2),
      resizeListener = _useResizeAware2[0],
      sizes = _useResizeAware2[1];

  return /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: {
      listRef: listRef,
      resizeListener: resizeListener,
      sizes: sizes,
      tab: tab
    }
  }, children);
}

export default /*#__PURE__*/React.memo(Tabs);